import { Button, FormGroup, Input, Label, Row, Col } from "reactstrap";

import "../../range.css";
import { useSitePlan } from "./UseSitePlan";

const SitePlanForm = () => {
  const {
    toggleUniformScaling,
    sitePlan,
    toggleLockSitePlanPosition,
    resetSitePlan,
    deleteSitePlan,
    setSitePlanDimension,
    setOpacity,
  } = useSitePlan();

  return (
    <div className="p-3">
      <FormGroup>
        <Label for="fileName">File Name</Label>
        <p>
          <b>{sitePlan?.name}</b>
        </p>
      </FormGroup>
      <FormGroup>
        <Label for="sitePlanOpacity">Opacity</Label>
        <Input
          type="range"
          name="sitePlanOpacity"
          onChange={(e) => setOpacity(parseFloat(e.target.value))}
          min={0.25}
          max={1}
          step={0.05}
          value={sitePlan?.opacity}
        />
      </FormGroup>
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Label for="width">Width (m)</Label>
            <Input
              type="number"
              step="1"
              min="1"
              id="width"
              name="width"
              value={sitePlan?.width}
              onChange={(e) => setSitePlanDimension("width", parseFloat(e.target.value))}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Label for="height">Height (m)</Label>
            <Input
              type="number"
              step="1"
              min="1"
              id="height"
              name="height"
              value={sitePlan?.height}
              onChange={(e) => setSitePlanDimension("height", parseFloat(e.target.value))}
            />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Button
          color="dark"
          block
          onClick={() => toggleUniformScaling()}
          className={sitePlan?.uniformScaling ? "active" : ""}
        >
          <div className="d-flex justify-content-between align-items-center">
            <span>Uniform Scaling</span>
            <i className={`icon-${sitePlan?.uniformScaling ? "check" : "cross"}-solid`}></i>
          </div>
        </Button>
        <Button
          color="dark"
          block
          onClick={() => toggleLockSitePlanPosition()}
          className={sitePlan?.lockSitePlanPosition ? "active" : ""}
        >
          <div className="d-flex justify-content-between align-items-center">
            <span>Lock Site Plan Position</span>
            <i className={`icon-${sitePlan?.lockSitePlanPosition ? "check" : "cross"}-solid`}></i>
          </div>
        </Button>
      </FormGroup>
      <Button color="primary" block onClick={resetSitePlan}>
        Reset
      </Button>
      <Button id="site-plan-delete" color="danger" block onClick={() => deleteSitePlan()}>
        Delete
      </Button>
    </div>
  );
};

export default SitePlanForm;
